const thanks1 = (data) => {
  const color = data.color;

  return {
    id: "TBGj8e-0Ds",
    elements: [
      {
        type: "shape",
        id: "0qOTQsBLvB",
        width: 82.79002624671915,
        height: 82.79002624671915,
        left: 917.2099737532808,
        top: 0,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "RtgBHG4aSh",
        width: 49.22656167979003,
        height: 49.22656167979003,
        left: 866.6520734908137,
        top: 82.79002624671915,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "uHiDh56uwo",
        width: 33.40293963254593,
        height: 33.40293963254593,
        left: 900.9690288713911,
        top: 176.25333333333333,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Y2mH9GtyIl",
        width: 82.79002624671915,
        height: 82.79002624671915,
        left: 0,
        top: 479.70992125984253,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "vdoRGTa8yF",
        width: 49.22656167979003,
        height: 49.22656167979003,
        left: 82.79002624671915,
        top: 430.4834645669291,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "IzJVhFj4z0",
        width: 33.40293963254593,
        height: 33.40293963254593,
        left: 66.08860892388451,
        top: 355.8763254593176,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "XiWcAS6bdf",
        width: 16.458477690288714,
        height: 16.458477690288714,
        left: 185.1576902887139,
        top: 488.43821522309713,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "gHSE95FGpJ",
        width: 791.2203674540682,
        height: 151.25,
        left: 82.79002624671915,
        top: 90.78089238845145,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><span style="font-size: 87.5px;font-family: Microsoft Yahei;color: ${color}">THANKS</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "d3V2z35wTf",
        width: 405.50719160104984,
        height: 57.5,
        left: 274.726719160105,
        top: 305.45805774278216,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><span style="font-size: 25px;font-family: Microsoft Yahei;color: ${color}">感谢观看</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],
    background: {
      type: "solid",
      color: `#fff`,
    },
  };
};

export default thanks1;
